import React, { useState } from "react";

const Accordion = ({ children, title }) => {
  const [isOpen, setIsOpen] = useState(false);

  function changeSelection() {
    setIsOpen(!isOpen);
  }

  return (
    <div className={`accordion-items alt${isOpen ? " open" : ""}`}>
      <div className="title" onClick={changeSelection}>
        <h5>{title}</h5>
        <div className="icons">
          <i className="icon icon-arrow-down-short"></i>
          <i className="icon icon-arrow-up-short"></i>
        </div>
      </div>

      {isOpen && <div className="content-accordion">{children}</div>}
    </div>
  );
};

export default Accordion;
